export class ModPass {
	oldPassword: string;
	newPassword: string;
	cNewPassword: string;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/mod-pass.ts